import { createContext, useContext } from 'react';

const NodeTypeContext = createContext([]);

export const NodeTypeProvider = NodeTypeContext.Provider;

export const useNodeTypeRegistry = () => useContext(NodeTypeContext);

export default NodeTypeContext;
